<template lang="pug">
.send-document-template-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
  )
    // ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません

    // セル：テンプレート名
    template(#cell(name)="row")
      span {{ row.item.name }}
    // セル：タイトル
    template(#cell(title)="row")
      span {{ row.item.title }}
    // セル：記載者
    template(#cell(writer)="row")
      span {{ row.item.writtenBy }}
    // セル：操作
    template(#cell(operation)="row")
      button.btn.detail-btn(@click="onDetail(row.item)" type="button") 詳細
      button.btn.edit-btn(@click="onEdit(row.item)" type="button") 修正
      button.btn.delete-btn(@click="onDelete(row.item)" type="button") 削除
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";
import { SendMessageTemplatesGetModel } from "@/commons/services/SendMessageTemplates";

/**
 * ### 文書送付カテゴリーテーブルコンポーネント
 */
@Component({})
export default class SendMessageTemplateTable extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<SendMessageTemplateTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<SendMessageTemplateTableField>;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;

  get _value(): Array<SendMessageTemplateTableItem> {
    return this.value;
  }

  /**
   * ### 詳細ボタン押下イベント
   */
  public onDetail(item: SendMessageTemplateTableItem): void {
    this.$emit("onDetail", item);
    return;
  }

  /**
   * ### 修正ボタン押下イベント
   */
  public onEdit(item: SendMessageTemplateTableItem): void {
    this.$emit("onEdit", item);
    return;
  }

  /**
   * ### 削除ボタン押下イベント
   */
  public onDelete(item: SendMessageTemplateTableItem): void {
    this.$emit("onDelete", item);
    return;
  }
}

/** テーブルの列名の情報 */
export interface SendMessageTemplateTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface SendMessageTemplateTableItem extends SendMessageTemplatesGetModel {}
</script>

<style lang="scss" scoped>
.send-document-template-table-component {
  .detail-btn,
  .edit-btn,
  .delete-btn {
    width: 64px;
  }
  .detail-btn,
  .edit-btn {
    margin-right: 8px;
  }
}
</style>
